var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4473 11.5467L14.4208 8.52018H18.6579C20.3225 8.52018 21.6844 9.88209 21.6844 11.5467V15.7837L18.6579 12.7573V11.5467H17.4473ZM33.7903 11.5467V8.52018H27.7374C26.0728 8.52018 24.7109 9.88209 24.7109 11.5467V14.5731C24.7109 16.2377 26.0728 17.5996 27.7374 17.5996H30.7638V20.6261H26.5268L29.5533 23.6526H30.7638C32.4284 23.6526 33.7903 22.2907 33.7903 20.6261V17.5996C33.7903 15.9351 32.4284 14.5731 30.7638 14.5731H27.7374V11.5467H33.7903ZM32.4284 30.4622L30.4612 32.4294L20.7765 22.7446C20.3225 23.1986 19.5659 23.6526 18.6579 23.6526H12.605V14.4218L9.57847 11.3953V23.6526H6.55199V17.5996H3.52551V23.6526H0.499023V11.5467C0.499023 9.88209 1.86094 8.52018 3.52551 8.52018H6.70331L0.650348 2.46721L2.61756 0.5L32.4284 30.4622ZM6.55199 11.5467H3.52551V14.5731H6.55199V11.5467ZM18.6579 20.4748L15.6314 17.4483V20.6261H18.6579V20.4748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdFree);
export default __webpack_public_path__ + "static/media/ad-free.1dc21ccb0988485066e8dbd6ba61958e.svg";
export { ForwardRef as ReactComponent };